import { getLanguageCode } from '../utilities';

export default class CartClient
{
    constructor()
    {
        let languageCode = getLanguageCode();

        this._uri = '/api-cart-' + languageCode;
        this._dataSrc = 'cart';
    }

    get uri()
    {
        return this._uri;
    }

    get dataSrc()
    {
        return this._dataSrc;
    }

    /**
	 * GET
	 */
    fetchAll()
    {
        return fetch(this._uri + '/items/all');
    }

    fetchItemsWithParams(params)
    {
        return fetch(this._uri + '/items?' + params);
    }

    fetchSummary()
    {
        return fetch(this._uri);
    }

    /**
	 * POST
	 */

    /**
	 * PUT
	 */
    update(data)
    {
        return fetch(this._uri + '/items', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    }

    /**
	 * DELETE
	 */

    /**
	 * @returns {Promise<Response>}
	 */
    delete()
    {
        return fetch(this._uri, {
            method: 'DELETE',
        });
    }

    deleteItems(data)
    {
        return fetch(this._uri + '/items', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    }
}
